import type { ParamMatcher } from '@sveltejs/kit';

const uuidRegex = /^[0-9a-f]{32}$/i;

export const match: ParamMatcher = (param) => {
    return uuidRegex.test(param);
};
